import { createSelector } from 'reselect';
import find from 'lodash/find';
import get from 'lodash/get';
import fromPairs from 'lodash/fromPairs';
import keyBy from 'lodash/keyBy';
import filter from 'lodash/filter';

import { formatDisplayName } from 'utils/recipientSearch';
import { buildWebhookURL } from 'utils/integrations';

export function sortByDisplayName(recipientA, recipientB) {
  const nameA = recipientA.displayName.toUpperCase();
  const nameB = recipientB.displayName.toUpperCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  return 0;
}

export function getConfigById(state, props) {
  const data = get(state, 'integrationConfigs.data', []);
  return find(data, { id: props.id });
}

export default createSelector([getConfigById], (config = {}) => {
  const inboundWebhooks = filter(get(config, 'integrations.data', []), {
    type: 'INBOUND_WEBHOOK',
  });

  const planConstants = keyBy(get(config, 'constants.data', []), 'name');
  const integrations = keyBy(get(config, 'integrations.data', []), 'name');
  const endpoints = keyBy(get(config, 'endpoints.data', []), 'name');

  return {
    config,
    integrations: integrations || {},
    endpoints: endpoints || {},
    constants: planConstants || {},
    initialValues: {
      id: config.id,
      name: config.name,
      configDescription: config.description,
      emailDisplayName: get(
        config,
        'forms.data[0].senderOverrides.displayName',
      ),
      recipients: get(config, 'forms.data[0].recipients.data', [])
        .map(recipient => ({
          ...recipient,
          displayName: formatDisplayName(recipient),
        }))
        .sort(sortByDisplayName),
      inboundWebhooks,
    },
    webhookUrls: fromPairs(
      inboundWebhooks.map(webhook => [webhook.name, buildWebhookURL(webhook)]),
    ),
  };
});
